import React from "react"
import { observer } from "mobx-react"

import InputTitle from "./InputTitle"
import Spacer from "~/components/Spacer"
import Dropdown from "~/components/Form/Dropdown"
import FormError from "~/components/Form/ErrorText"
import useInject from "~/hooks/useInject"

export const VA_REGIONS = {
  "Northern Virginia": [
    "Alexandria", "Arlington", "Clarke", "Culpeper", "Fairfax City",
    "Fairfax County", "Falls Church", "Fauquier", "Frederick",
    "Fredericksburg", "King George", "Loudoun", "Prince William",
    "Rappahannock", "Spotsylvania", "Stafford", "Warren", "Winchester",
  ],
  "Hampton Roads": [
    "Chesapeake", "Gloucester", "Hampton", "Isle of Wight", "Mathews",
    "Newport News-Civil", "Newport News-Criminal", "Newport News-Traffic",
    "Norfolk", "Norfolk-Criminal Division", "Norfolk-Traffic Division",
    "Norfolk-Civil Division", "Portsmouth", "Suffolk", "Virginia Beach",
    "Williamsburg/James City County", "York",
  ],
  "Richmond Metro": [
    "Charles City", "Chesterfield", "Colonial Heights", "Dinwiddie",
    "Goochland", "Hanover", "Henrico", "Hopewell", "New Kent",
    "Petersburg", "Powhatan", "Prince George", "Richmond City",
    "Richmond-Civil", "Richmond-Marsh Criminal/Traffic",
    "Richmond-John Marshall Criminal/Traffic", "Richmond Manchester",
  ],
  "Shenandoah Valley": [
    "Augusta", "Bath", "Buena Vista", "Harrisonburg/Rockingham",
    "Highland", "Lexington/Rockbridge", "Page", "Shenandoah",
    "Staunton", "Waynesboro",
  ],
  "Central Virginia": [
    "Albemarle", "Charlottesville", "Fluvanna", "Greene", "Louisa",
    "Madison", "Nelson", "Orange",
  ],
  "Roanoke Area": [
    "Alleghany", "Botetourt", "Craig", "Floyd", "Giles",
    "Montgomery/Christiansburg", "Pulaski", "Radford",
    "Roanoke City", "Roanoke County", "Salem",
  ],
  "Southwest Virginia": [
    "Bland", "Bristol", "Buchanan", "Carroll", "Dickenson", "Galax",
    "Grayson", "Henry", "Lee", "Martinsville", "Patrick", "Russell",
    "Scott", "Smyth", "Tazewell", "Washington", "Wise/Norton", "Wythe",
  ],
  "Southside Virginia": [
    "Amelia", "Brunswick", "Charlotte", "Danville", "Emporia",
    "Franklin City", "Franklin County", "Greensville", "Halifax",
    "Lunenburg", "Mecklenburg", "Nottoway", "Pittsylvania",
    "Prince Edward", "Southampton", "Surry", "Sussex",
  ],
  "Lynchburg Area": [
    "Amherst", "Appomattox", "Bedford", "Buckingham", "Campbell",
    "Cumberland", "Lynchburg",
  ],
  "Eastern Shore & Northern Neck": [
    "Accomack", "Caroline", "Essex", "King William", "King and Queen",
    "Lancaster", "Middlesex", "Northampton", "Northumberland",
    "Richmond County", "Westmoreland",
  ],
}

// Ordered by expected search volume: population centres first, then the
// I-81 / I-95 corridors where out-of-state speeding citations concentrate.
const REGION_OPTIONS = Object.keys(VA_REGIONS).map((name) => ({
  value: name,
  label: name,
}))

const mapStore = (store) => ({
  courtFilter: store.trafficLookup.courtFilter,
  setCourtFilter: store.trafficLookup.setCourtFilter,
  validateDisplayMessage: store.trafficLookup.validateDisplayMessage,
})

const CourtSelector = () => {
  const { courtFilter, setCourtFilter, validateDisplayMessage } =
    useInject(mapStore)
  const error = validateDisplayMessage("courtFilter")

  return (
    <>
      <InputTitle>
        Region
        <Spacer direction="width" mobile={11} desktop={11} />
      </InputTitle>
      <Spacer desktop={16} mobile={4} />
      <Dropdown
        autoFocus={false}
        blurInputOnSelect
        maxMenuHeight={140}
        placeholder="Select your court region"
        value={courtFilter ? { value: courtFilter, label: courtFilter } : null}
        onChange={(option) => setCourtFilter(option?.value || "")}
        options={REGION_OPTIONS}
        error={error}
        bold={false}
      />
      <FormError error={error} />
    </>
  )
}

export default observer(CourtSelector)
